<template>
    <div v-if="products && products.length > 0">
        <h2 v-if="title" v-text="title"></h2>
        <b-card-group v-for="(productGroup, index) in products" :key="index" class="mt-3 mb-3 row border-bottom pb-3">
            <b-card v-for="product in productGroup" :key="product.id" :img-alt="product.name"
                    :img-src="product.image ? product.image : '/images/default-product-image.jpg'"
                    :title="product.name"
                    class="product col-4" img-top>
                <template #footer>
                    <b-button
                        size="sm"
                        class="mr-1"
                        type="button"
                        variant="danger"
                        :disabled="isLoading"
                        @click="viewProduct(product)">
                        View
                    </b-button>

                    <b-button
                        v-if="!isReseller"
                        size="sm"
                        type="button"
                        variant="danger"
                        :disabled="!hasManagerPermission('products.edit') || projectProducts.filter(projectProduct => projectProduct.id === product.id).length > 0 || isLoading"
                        @click="addProductToProject(product)">
                        Select
                    </b-button>
                </template>
            </b-card>

            <b-card v-if="productGroup.length < 4"
                    v-for="index in 4 - productGroup.length"
                    class="product col-4 opacity-0"
                    :key="index"
                    img-top/>
        </b-card-group>
    </div>
</template>

<script>
import axios from "axios";

export default {
    props: {
        products: null,
        projectProducts: null,
        title: '',
        isReseller: false,
    },
    components: {},
    data() {
        return {
            selectedProduct: null,
            isLoading: false
        }
    },
    methods: {
        viewProduct(product) {
            this.$emit('viewProduct', product);
        },

        reloadProjectProducts(stayOnPage) {
            this.$emit('reloadProjectProducts', stayOnPage);
        },

        addProductToProject(product) {
            this.isLoading = true;
            let token = this.$store.state.token;

            let url = this.$store.getters.apiProjectBase + '/products/' + product.id + '/add';
            let method = 'GET';

            return axios({
                url: url,
                method: method,
                headers: {"Authorization": "Bearer " + token}
            })
                .then(() => {
                    this.isLoading = false;
                    this.reloadProjectProducts(true);
                })
                .catch(error => {
                    alert('Something went wrong');
                    this.isLoading = false;
                    console.log(error);
                });
        },
    }
}
</script>

